import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { LogoMark } from "../components/Logo";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.id) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2B2B2B] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <div className="bg-[#F7F3EC] p-3">
            <LogoMark size={48} />
          </div>
        </div>
        <div className="bg-[#F7F3EC] p-8 lg:p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={20} className="text-[#C68B4E]" strokeWidth={1.5} />
            <h1 className="text-2xl font-extrabold tracking-tight">Admin Login</h1>
          </div>
          <p className="text-sm text-[#5C5C5C] mb-8">Sign in to view quote submissions.</p>

          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-xs uppercase tracking-widest font-bold">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="rounded-none border-[#2B2B2B]/20 bg-white h-12 focus-visible:ring-[#C68B4E] focus-visible:ring-offset-0" data-testid="admin-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-xs uppercase tracking-widest font-bold">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="rounded-none border-[#2B2B2B]/20 bg-white h-12 focus-visible:ring-[#C68B4E] focus-visible:ring-offset-0" data-testid="admin-password-input" />
            </div>
            {error && <p className="text-sm text-red-600 font-semibold" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full bg-[#C68B4E] text-white hover:bg-[#B37A3D] transition-colors py-4 text-sm font-bold tracking-wider uppercase disabled:opacity-60" data-testid="admin-login-button">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
        <p className="text-center text-[#F7F3EC]/40 text-xs mt-6">Bright Oak Renovations · Staff Only</p>
      </div>
    </div>
  );
};

export default AdminLogin;
